import React from 'react';
import Helmet from 'react-helmet';

export default () => (
  <Helmet>
    <script type="application/ld+json">
      {`{
          "@context": "http://schema.org",
          "@type": "Service",
          "name": "HousingAnywhere.com",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5",
            "reviewCount": "93"
          }
        }
      `}
    </script>
  </Helmet>
);
